var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighlighterActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1529_7876",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1529_7876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 35.6869H20.0002C16.8994 35.6869 14.0033 34.783 11.5639 33.2278C13.3058 30.2183 16.4845 28.3681 20.0002 28.3681C23.5159 28.3681 26.6947 30.2184 28.4365 33.228C25.919 34.8352 22.9918 35.6897 20.0005 35.6869ZM25.1615 16.4732V8.77277C25.1615 8.09068 24.8105 7.46487 24.2423 7.11219L24.2423 7.11216L24.2378 7.10944C23.6591 6.76224 22.9379 6.71926 22.3276 7.03331C22.3269 7.03367 22.3262 7.03404 22.3255 7.0344L15.9179 10.2381C15.2446 10.5569 14.8388 11.2455 14.8388 11.9803V16.4732C13.9292 16.6391 13.2351 17.4394 13.2351 18.3954V26.2414C11.3525 27.3159 9.7318 28.8244 8.53519 30.7051C5.82046 27.8083 4.30646 23.981 4.31243 19.9997V19.9992C4.31243 11.3557 11.3567 4.31145 20.0002 4.31145C28.6437 4.31145 35.6879 11.3557 35.6879 19.9992C35.6879 24.1371 34.0892 27.8964 31.4644 30.7049C30.2862 28.857 28.6733 27.3239 26.7653 26.2408V18.3954C26.7653 17.4394 26.0711 16.6391 25.1615 16.4732ZM20.0002 0.403906C9.18989 0.403906 0.404883 9.18891 0.404883 19.9992C0.404883 30.8095 9.18989 39.5945 20.0002 39.5945C30.8104 39.5945 39.5954 30.8095 39.5954 19.9992C39.5954 9.18891 30.8104 0.403906 20.0002 0.403906ZM22.8577 20.3492V24.4605H17.1426V20.3492H22.8577ZM18.7464 16.4416V13.191L21.2539 11.9372V16.4416H18.7464Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlighterActive);
export default __webpack_public_path__ + "static/media/highlighter_active.e1254efd999632fe7cd2bb0daee0ac69.svg";
export { ForwardRef as ReactComponent };